classifier.filter('classifiersExist', (classifierService) => {
    "use strict";
    return (additionalClassifications, type) => {

        let dkSchems = classifierService.getGroupSchemeByType(type);
        return (additionalClassifications || []).filter((cl) => {
            return dkSchems.has(cl.scheme);
        }).length > 0;
    }
});